import BaseRepository from "@/services/resources/repository";
import byProject from "@/services/resources/mixins/query-by-project";
import byKeyword from "@/services/resources/mixins/query-by-keyword";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(byProject).$mix(byKeyword);
    }
}

export default Repository;
